import { render, staticRenderFns } from "./ProductModal.vue?vue&type=template&id=141e7f67&scoped=true&"
import script from "./ProductModal.vue?vue&type=script&lang=js&"
export * from "./ProductModal.vue?vue&type=script&lang=js&"
import style0 from "./ProductModal.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ProductModal.vue?vue&type=style&index=1&id=141e7f67&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141e7f67",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\collection-gifting\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('141e7f67')) {
      api.createRecord('141e7f67', component.options)
    } else {
      api.reload('141e7f67', component.options)
    }
    module.hot.accept("./ProductModal.vue?vue&type=template&id=141e7f67&scoped=true&", function () {
      api.rerender('141e7f67', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "CollectionGifting/components/Snippets/ProductModal.vue"
export default component.exports